import React from "react";
import { Card } from "../ui/Card";
import { ReportsPanel } from "./ReportsPanel";
import { type ScanRecord } from "../../services/StorageService";

interface ActivityReportsPanelProps {
  onSelectOperator: (operatorName: string) => void;
  onGenerateReport: (
    reportType: string,
    params?: { endDate?: string; startDate?: string; date?: string }
  ) => void;
  availableDates: string[];
  scanHistory: Record<string, ScanRecord[]>;
}

export const ActivityReportsPanel: React.FC<ActivityReportsPanelProps> = () => {
  return (
    <div className="flex flex-row gap-4 w-full h-full">
      <Card padding="md" className="overflow-auto w-full">
        <ReportsPanel />
      </Card>
    </div>
  );
};
